export const useStyles = theme => ({
    root: {
        width: "100%"
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    table: {
        
    },
    tableHead: {
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    tableRow: {
        width: "100%",
        overflow: "hidden",
        padding: "10px",
        paddingLeft: 5,
        borderLeftWidth:5,
        borderLeftColor: "transparent" ,
        borderLeftStyle: "solid",
        paddingRight:5

    },

    advTypeContent: {
        width: "100%",
        display: "flow-root",

    },
    advStatus: {
        
        
        

    },
    exceptionAdv: {
        borderLeftWidth:5,
        borderLeftColor: theme.palette.error.main,
        borderLeftStyle: "solid"
    },
    advTypeName: {
        float: "left",
        paddingLeft: 2,
        width: "180px"
    },
    privateNoteIcon: {
        marginRight: "10px",
        float: "left",
        fontSize: 12,
        color: "rgba(0,0,0,0.4)"
    },
    dateContainer : {
        float:"left",
        width: 110
    },
    dataContainer: {
        float:"left",
        marginLeft:10,
        width: "calc(100% - 120px)"
    },
    exceptionIcon: {
        color: theme.palette.error.main
    } ,
    lenText: {
        float: "left", marginRight: "3px", minWidth: 80, width: 80
    },
    subRow: {
        marginTop: 7,
        width: "100%"
    },
    advNameContainer: {
        marginTop: 0,
        marginBottom: 7,
        maxHeight: 43,
        overflowY:"hidden"
    },
    
    
    
    
    visuallyHidden: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        top: 20,
        width: 1,
    },
    label: {
        display: "block",
        width: "100%",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    selectedRow: {
        backgroundColor: "#00968733 !important",
        "&:hover": {
            backgroundColor: "#00968766 !important",
            cursor: "pointer !important"
        }
    }
});